import Vue from 'vue';
import Router from 'vue-router';
import LastArticles from '@/components/LastArticles';
import ArticlePage from '@/components/ArticlePage';
import PressReleasePage from '@/components/PressReleasePage';
import ArticlesForCategory from '@/components/ArticlesForCategory';
import RGPD from '@/components/RGPD';
import NotFound from '@/components/NotFound';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/articles/:id/:slug',
      name: 'ArticlePage',
      component: ArticlePage,
    },
    {
      path: '/',
      name: 'LastArticles',
      component: LastArticles,
    },
    {
      path: '/articles/categorie/:category/:categoryValue',
      name: 'ArticlesForCategory',
      component: ArticlesForCategory,
    },
    {
      path: '/articles/:query?',
      name: 'ArticlesSearch',
      component: LastArticles,
    },
    {
      path: '/communiques-de-presse/:id/:slug',
      name: 'PressReleasePage',
      component: PressReleasePage,
    },
    {
      path: '/rgpd',
      name: 'RGPD',
      component: RGPD,
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js